export default __webpack_public_path__ + "static/13-44bde5e6fec21e065b331de5fb7775cd.jpg";